import { CommonModule } from '@angular/common'
import {
  Component, ChangeDetectionStrategy, Input,
} from '@angular/core'
import { RouterOrExternalLinkDirective } from '@knorr-bremse-portals/ngx-components'

@Component({
  selector: 'kb-header-title',
  templateUrl: './header-title.component.html',
  styleUrls: ['./header-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterOrExternalLinkDirective],
})
export class HeaderTitleComponent {
  @Input() public href?: string
}
